"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _help = _interopRequireDefault(require("@ux/icon/help"));
var _uxUtils = require("@site/ux-utils");
var _utils = require("@site/utils");
var _sharedComponents = require("@site/shared-components");
const getContainerClasses = isMobile => {
  return (0, _classnames.default)('d-flex', {
    'text-right align-items-center': !isMobile
  });
};
const getPriceBlockClasses = (isMobile, isExtensionOnlyCard) => {
  return (0, _classnames.default)('d-flex flex-column text-default', {
    'align-items-end mr-4': !isMobile && !isExtensionOnlyCard,
    'align-items-start': isMobile || isExtensionOnlyCard
  });
};
const getPriceSpanClasses = (isMobile, priceColorClass, styleOverrides) => {
  return (0, _classnames.default)({
    ms4: !isMobile,
    ms0: isMobile,
    [priceColorClass]: !styleOverrides.mainPriceStyle?.color
  });
};
const renderMobileHeroIcon = (isMobile, customHeroImage) => {
  if (!isMobile) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center pr-1"
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.HeroIcon, {
    border: true,
    height: 56,
    width: 56,
    customImage: customHeroImage
  }));
};
const renderPriceSuffix = showSuffix => {
  if (!showSuffix) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ms-2"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "dbsPriceSuffix"
  }));
};
const DbsPriceBlock = ({
  domain = {},
  dbsPrice,
  options = {},
  plid = 1,
  language = {},
  eidPrefix = '',
  customHeroImage,
  isExtensionOnlyCard
}) => {
  const {
    isMobile
  } = (0, _uxUtils.useDeviceType)();
  const market = (0, _utils.getMarket)();
  const {
    Fqdn
  } = domain;
  const {
    showSuffix = true,
    classNames = {}
  } = options;
  const {
    styleOverrides = {}
  } = classNames;
  const priceColorClass = (0, _utils.isReseller)(plid) ? 'text-primary-o' : 'text-black';
  const priceTitleId = (0, _utils.isReseller)(plid) ? 'dbsPriceTitleReseller' : 'dbsPriceTitle';
  return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
    locale: market,
    key: market,
    messages: language
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": `${Fqdn}_price`,
    "data-testid": `${Fqdn}_price`,
    className: getContainerClasses(isMobile)
  }, renderMobileHeroIcon(isMobile, customHeroImage), /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "dbs-price-block",
    className: getPriceBlockClasses(isMobile, isExtensionOnlyCard)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ms-2 m-0"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: priceTitleId
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "domain-taken-dbs-price",
    className: "d-flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "domain-taken-dbs-main-price"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: getPriceSpanClasses(isMobile, priceColorClass, styleOverrides),
    style: styleOverrides.mainPriceStyle
  }, dbsPrice), /*#__PURE__*/_react.default.createElement(_sharedComponents.TooltipWrapper, {
    dataCy: 'dbs-price-tooltip',
    title: /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "pricing.price-conditions-tooltip.pricing-header"
    }),
    tooltipContent: /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "dbsPriceTooltipMessage"
    }),
    tooltipButtonText: /*#__PURE__*/_react.default.createElement("span", {
      className: "text-default",
      "data-eid": `${eidPrefix}domain_dbs.price_tooltip.click`
    }, /*#__PURE__*/_react.default.createElement(_help.default, {
      height: 16,
      width: 16
    })),
    id: "dbsPriceTooltipTitle"
  }))), renderPriceSuffix(showSuffix))));
};
DbsPriceBlock.propTypes = {
  language: _propTypes.default.object.isRequired,
  eidPrefix: _propTypes.default.string.isRequired,
  dbsPrice: _propTypes.default.string.isRequired,
  domain: _propTypes.default.object.isRequired,
  options: _propTypes.default.object,
  plid: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  customHeroImage: _propTypes.default.string
};
var _default = exports.default = DbsPriceBlock;